var f = {
  "./de.js": 74,
  "./en.js": 75,
  "./es.js": 76,
  "./kr.js": 77,
  "./pr.js": 78,
};
var fml = {
  "./de.js": require("./de.js"),
  "./en.js": require("./en.js"),
  "./es.js": require("./es.js"),
  "./kr.js": require("./kr.js"),
  "./pr.js": require("./pr.js"),
};
function g(j) {
  return fml[j];
  // return require(require("path").join(__dirname, "../i18n/") + j.slice(2));
}
function h(j) {
  // // if (!require.o(f, j)) {
  //   var k = new Error("Cannot find module '" + j + "'");
  //   k.code = "MODULE_NOT_FOUND";
  //   throw k;
  // }
  return f[j];
}
g.keys = function () {
  return Object.keys(f);
};
g.resolve = h;
module.exports = g;
g.id = 73;
